import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';

import { OEButton } from '../../atoms/oe-button/oe-button';
import { OEText } from '../../atoms/oe-text/oe-text';
import RoundPanel from '../../atoms/round-panel/round-panel';
import { flex } from '../../style-utils';

const onboardingImage = require('../../assets/onboarding-banner/onboarding-banner-image.png');

export type OnboardingBannerProps = {
  onStartPress: () => void;
};

export const OnboardingBanner = ({ onStartPress }: OnboardingBannerProps) => {
  const { t } = useTranslation();

  return (
    <Panel shadow="large">
      <CardText>{t('onboarding.platformTour.banner.title')}</CardText>
      <View style={[flex('flex-row', 'justify-content-between', 'flex-1')]}>
        <OEButton type="accent" size="large" onPress={onStartPress}>
          {t('onboarding.platformTour.banner.button')}
        </OEButton>
        <StyledImage source={onboardingImage} />
      </View>
    </Panel>
  );
};

const CardText = styled(OEText).attrs(({ theme }) => ({
  fontFamily: theme.secondaryFont.regular,
}))`
  width: 100%;
  padding-bottom: 16px;
  font-size: 14px;
`;

type StyledBackgroundType = {
  backgroundColor?: string;
};

const Panel = styled(RoundPanel)<StyledBackgroundType>`
  padding: 16px;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ?? theme.color.white};
`;

const StyledImage = styled(Image)`
  height: 38px;
  width: 64px;
  border-radius: 4px;
`;

export default OnboardingBanner;
